import React from 'react';
import { Table, Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { WhitelistedIp } from '../types/admin.types';

interface IpWhitelistTableProps {
    ips: WhitelistedIp[];
    loading: boolean;
    isSuperAdmin: boolean;
    onDelete: (id: number) => void;
}

export const IpWhitelistTable: React.FC<IpWhitelistTableProps> = ({
    ips,
    loading,
    isSuperAdmin,
    onDelete
}) => {
    const columns: ColumnsType<WhitelistedIp> = [
        {
            title: 'IP Address',
            dataIndex: 'ip_address',
            key: 'ip',
        },
        {
            title: 'Label',
            dataIndex: 'label',
            key: 'label',
        },
        {
            title: 'Added At',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (date: string) => new Date(date).toLocaleDateString()
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_: any, record: WhitelistedIp) => (
                isSuperAdmin && (
                    <Popconfirm
                        title="Remove IP?"
                        onConfirm={() => onDelete(record.id)}
                    >
                        <Button danger icon={<DeleteOutlined />} size="small" />
                    </Popconfirm>
                )
            )
        }
    ];

    return (
        <Table
            dataSource={ips}
            columns={columns}
            rowKey="id"
            loading={loading}
            pagination={{
                total: ips.length,
                pageSize: 10,
                showTotal: (total) => `Total ${total} IPs`,
            }}
        />
    );
};
